import React from 'react'
import { Trans } from '@mc/i18n'
import { GiftTermsLink } from '@mc/legal'
import { paths } from '@mc/paths'
import { trackFreeGiftMembershipFaqLinkClick } from '../../events/pageClick'
import { i18nInstance, PLAN_Z_BOGO_I18N_NAMESPACE } from '../../i18n'

const t = i18nInstance.getFixedT(null, PLAN_Z_BOGO_I18N_NAMESPACE)

const AnswerComponent = () => (
  <>
    <p className='mc-opacity--hinted'>
      <Trans
        i18nKey='faq.general.freeGiftMembership.answer.p1'
        ns={PLAN_Z_BOGO_I18N_NAMESPACE}
      />
    </p>
    <p className='mc-opacity--hinted mc-mt-3'>
      <Trans
        i18nKey='faq.general.freeGiftMembership.answer.p2'
        ns={PLAN_Z_BOGO_I18N_NAMESPACE}
        components={{
          learnMoreLink: (
            <a
              className='mc-text--link'
              href={paths.giftSupport}
              target='_blank'
              rel='noopener noreferrer'
              onClick={trackFreeGiftMembershipFaqLinkClick}
            />
          ),
        }}
      />
    </p>
    <p className='mc-opacity--hinted mc-mt-3'>
      <Trans
        i18nKey='faq.general.freeGiftMembership.answer.p3'
        ns={PLAN_Z_BOGO_I18N_NAMESPACE}
        components={{ terms: <GiftTermsLink /> }}
      />
    </p>
  </>
)

export const FAQ_UUID = 'How Do I Use The Free Gift Membership'

export const freeGiftMembershipFAQ = ({
  hide = true,
}: {
  hide?: boolean
} = {}) => [
  {
    uuid: FAQ_UUID,
    label: t(
      `${PLAN_Z_BOGO_I18N_NAMESPACE}:faq.general.freeGiftMembership.question`,
    ),
    title: t(
      `${PLAN_Z_BOGO_I18N_NAMESPACE}:faq.general.freeGiftMembership.question`,
    ),
    answer: <AnswerComponent />,
    hide,
  },
]
